import { createSlice, createSelector } from '@reduxjs/toolkit';
import {
  loginUser,
  registerUser,
  logout,
  forgotUserPassword,
  resetPassword,
} from './authActions';
import { decodeToken } from '../../../utils/decodeToken';
import { encryptData } from '../../../utils/encryptData';

const initialState = {
  loading: false,
  isAuthenticated: false,
  em: null, //email
  rl: null, //Role
  uid: null, //userId
  verify: null,
  username: null,
  mobile: null,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // User registration
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state) => {
        state.token = null;
        state.error = null;
        state.loading = false;
      })
      .addCase(registerUser.rejected, (state, { payload }) => {
        state.error = payload?.error || 'Registration failed';
        state.loading = false;
      })

      //User Login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, { payload }) => {
        state.isAuthenticated = true;

        const decodeResult = decodeToken(payload?.token);
        state.em = encryptData(decodeResult.email);
        state.rl = encryptData(decodeResult.role);
        state.uid = encryptData(decodeResult.uid);
        state.mobile = encryptData(decodeResult.phone_number);
        state.username = decodeResult.name;

        if (decodeResult.Verify === 'verified') {
          state.verify = true;
        } else {
          state.verify = false;
        }
        state.loading = false;
      })
      .addCase(loginUser.rejected, (state, { payload }) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.error = payload?.error || 'Login failed';
      })

      //   Forgot Password
      .addCase(forgotUserPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(forgotUserPassword.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(forgotUserPassword.rejected, (state, { payload }) => {
        state.error = payload?.error || 'Reset code send failed';
        state.loading = false;
      })

      //  reset Password
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(resetPassword.rejected, (state, { payload }) => {
        state.error = payload?.error || 'Password reset failed';
        state.loading = false;
      })

      // Logout
      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logout.fulfilled, (state) => {
        state.isAuthenticated = false;
        state.loading = false;
        state.em = null;
        state.rl = null;
        state.uid = null;
        state.verify = false;
      })
      .addCase(logout.rejected, (state, { payload }) => {
        state.error = payload?.error || 'Logout failed';
        state.loading = false;
      });
  },
});

const selectAuthState = (state) => state.auth;

// export const selectUserDetails = createSelector(
//   [selectAuthState],
//   (auth) => auth.userDetails
// );

export const {} = authSlice.actions;
export default authSlice.reducer; // This is important
